export default class MissingLineItemVariantError extends Error {
};
